import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import {
  getCsvProjectsDirectory, uploadCsvProjectsDirectory,
} from '../app/store/actions/projectsDirectory';
import ModalComponent from '../components/modal';
import UploadFilesComponent from '../components/upload';
import ImportErrors from '../components/upload/ImportErrors';
import ROUTES from '../data/routes';
import { history } from '../routers/AppRouter';

class UploadProjectsDirectoryPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      showModal: false,
      titleModal: '',
      titleModalBody: '',
      importMessage: null,
    };
  }

  sendFile = async (file) => {
    await this.setState({
      errors: {},
      importMessage: null,
    });
    try {
      const result = await this.props.uploadCsvProjectsDirectory(file);
      await this.setState({
        errors: (result && result.errors) || [],
        importMessage: (result && result.createdQuantity)
          ? I18n.t('successfulImportMessage', { 0: result.createdQuantity })
          : null,
      });
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError,
        });
      } else {
        this.setState({
          showModal: true,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch'),
        });
      }
    }
  }

  modelDownload = async () => {
    try {
      await this.props.getCsvProjectsDirectory();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError,
        });
      } else {
        this.setState({
          showModal: true,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch'),
        });
      }
    }
  }

  goBack = () => {
    history.push(ROUTES.PROJECTS_DIRECTORY);
  }

  render() {
    const {
      errors, showModal, titleModal, titleModalBody, importMessage,
    } = this.state;

    return (
      <div className="main-div-tables">
        <div className="main-table">

          <h2>{I18n.t('importProjectsDirectory')}</h2>

          <div className="upload-text">
            <p><strong>{I18n.t('importText1')}</strong></p>
            <p>{I18n.t('importText5')}</p>
            <p>{I18n.t('importText3')}</p>
            <p>{I18n.t('importText4')}</p>
            <p>{I18n.t('projectsDirectoryText1')}</p>
            <p>{I18n.t('projectsDirectoryText2')}</p>
          </div>

          <UploadFilesComponent
            sendFile={this.sendFile}
            goBack={this.goBack}
            modelDownload={this.modelDownload}
            importMessage={importMessage}
            itemsErrors={(
              <ImportErrors
                title={I18n.t('notImported')}
                errors={errors}
              />
            )}
          />

          <ModalComponent
            title={titleModal}
            body={titleModalBody}
            visible={showModal}
            closeModal={() => this.setState({ showModal: false })}
            titleOkButtoon={I18n.t('ok')}
            size={{ width: '350px', height: '200px' }}
            showButtons
            confirmModal={() => this.setState({ showModal: false })}
          />

        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  uploadCsvProjectsDirectory: file => dispatch(uploadCsvProjectsDirectory(file)),
  getCsvProjectsDirectory: () => dispatch(getCsvProjectsDirectory()),
});

export default connect(null, mapDispatchToProps)(UploadProjectsDirectoryPage);
